import { render, staticRenderFns } from "./SendAnnounceDetail.vue?vue&type=template&id=ebd8c134&scoped=true&"
import script from "./SendAnnounceDetail.vue?vue&type=script&lang=js&"
export * from "./SendAnnounceDetail.vue?vue&type=script&lang=js&"
import style0 from "./SendAnnounceDetail.vue?vue&type=style&index=0&id=ebd8c134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd8c134",
  null
  
)

export default component.exports